export default "__VITE_PUBLIC_ASSET__29ff391e__"